import moment from 'moment';
import React from 'react';
import { Cards } from '../../components/Card';
import { AuditLogType, UserType } from '../../graphql/generated/graphql';
import avatar1 from '../../images/leaderboard/avatar1.png';
import avatar2 from '../../images/leaderboard/avatar2.png';
import SettingsContainerView from '../../settings/SettingsContainerView';
import SettingsSectionUpsell from '../../settings/SettingsSectionUpsell';
import AuditLogRow from './AuditLogRow';

const AuditUpSellView = () => (
  <SettingsContainerView title="Audit Logs">
    <SettingsSectionUpsell
      description="Upgrade to monitor activity across your entire team. Search for members, filter by type of action, and reveal important details about your team’s Slab usage."
      feature="auditLog"
      contentCards={
        <Cards>
          <AuditLogRow
            auditLog={{
              id: '1',
              type: AuditLogType.LoginSuccess,
              insertedAt: moment('2020-08-23T22:15:00.000Z'),
              user: { id: '1' },
            }}
            user={{
              id: '1',
              name: 'Majorie Russel',
              avatar: avatar1,
              description: '',
              email: '',
              title: '',
              type: UserType.User,
            }}
          />
          <AuditLogRow
            auditLog={{
              id: '2',
              type: AuditLogType.PostDelete,
              insertedAt: moment('2020-08-03T09:10:00.000Z'),
              user: { id: '2' },
            }}
            user={{
              id: '1',
              name: 'Greg Xu',
              avatar: avatar2,
              description: '',
              email: '',
              title: '',
              type: UserType.User,
            }}
          />
        </Cards>
      }
    />
  </SettingsContainerView>
);

export default AuditUpSellView;
